<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="550px"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="file == null"
      >
        <upload
          :limit="3"
          :path="'class/declareClassPlan'"
          v-model="file"
          ref="removeFile"
          :accepts="accepts"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureImport" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Upload from "@/components/upload/index";

export default {
  components: { butn, Upload },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      file: [],
      accepts: [
        "word",
        "excel",
        "ppt",
        "pdf",
        "jpg",
        "png",
        "txt",
        "zip",
        "rar",
      ],
    };
  },
  methods: {
    closeDia() {
      this.$emit("close", false);
    },
    sureImport() {
      if (this.file != null) {
        this.$emit("upload", JSON.stringify(this.file));
      }
    },
  },
};
</script>

<style>
</style>